<header class="main__content__header modal-header">
    <h2 class="modal-title">{{nomeAta}}</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>
<main class="main__content__modal modal-body" *ngIf="pdfSrc">
    <pdf-viewer [src]="pdfSrc" [original-size]="true" [render-text]="true" [rotation]="0" [show-all]="false"
        [fit-to-page]="true" [zoom]="0.95" [zoom-scale]="'page-width'" [stick-to-page]="true"
        [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false" class="pdf-viewer" [page]="page"
        style="width: 100%; height: 70vh; overflow-x: hidden !important;" [page]="page"
        (after-load-complete)="afterLoadComplete($event)" />
</main>
<footer class="row">
    <section class="col-11 px-0 content-buttons" *ngIf="isLoaded">
        <button (click)="prevPage()">
            Voltar
        </button>
        <button (click)="nextPage()">
            Próximo
        </button>
    </section>
    <section class="col-1 px-0 content-pagina">
        {{page}} de {{totalPages}}
    </section>
</footer>